export default __webpack_public_path__ + "static/media/home-cafe-parallex-bg-img-01.cc098618.jpg";